import React from 'react';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import vegitable500 from '../images/optimized/vegitable500.webp';
import vegitable1000 from '../images/optimized/vegitable1000.webp';
import vegitable1500 from '../images/optimized/vegitable1500.webp';

import flower500 from '../images/optimized/flowers500.webp';
import flower1000 from '../images/optimized/flowers1000.webp';
import flower1500 from '../images/optimized/flowers1500.webp';

import spices500 from '../images/optimized/spices500.webp';
import spices1000 from '../images/optimized/spices1000.webp';
import spices1500 from '../images/optimized/spices1500.webp';


import onion500 from '../images/optimized/onion500.webp';
import onion1000 from '../images/optimized/onion1000.webp';
import onion1500 from '../images/optimized/onion1500.webp';

import watermelon500 from '../images/optimized/watermelon500.webp';
import watermelon1000 from '../images/optimized/watermelon1000.webp';
import watermelon1500 from '../images/optimized/watermelon1500.webp';

import mango500 from '../images/optimized/mango500.webp';
import mango1000 from '../images/optimized/mango1000.webp';
import mango1500 from '../images/optimized/mango1500.webp';

import papaya500 from '../images/optimized/papaya500.webp';
import papaya1000 from '../images/optimized/papaya1000.webp';
import papaya1500 from '../images/optimized/papaya1500.webp';

import greenandredchillies500 from '../images/optimized/greenandredchillies500.webp';
import greenandredchillies1000 from '../images/optimized/greenandredchillies1000.webp';
import greenandredchillies1500 from '../images/optimized/greenandredchillies1500.webp';

import ginger500 from '../images/optimized/ginger500.webp';
import ginger1000 from '../images/optimized/ginger1000.webp';
import ginger1500 from '../images/optimized/ginger1500.webp';

import gooseberry500 from '../images/optimized/gooseberry500.webp';
import gooseberry1000 from '../images/optimized/gooseberry1000.webp';
import gooseberry1500 from '../images/optimized/gooseberry1500.webp';

import foxnut500 from '../images/optimized/foxnut500.webp';
import foxnut1000 from '../images/optimized/foxnut1000.webp';
import foxnut1500 from '../images/optimized/foxnut1500.webp';

import mustard500 from '../images/optimized/mustard500.webp';
import mustard1000 from '../images/optimized/mustard1000.webp';
import mustard1500 from '../images/optimized/mustard1500.webp';



const products = [
  {
    name: "Vegitable and Fruits",
    alt: "vegitable_image",
    images: {
      small: vegitable500,
      medium: vegitable1000,
      large: vegitable1500,
    }
  },
  {
    name: "Flowers",
    alt: "flower_image",
    images: {
      small: flower500,
      medium: flower1000,
      large: flower1500,
    }
  },
  {
    name: "Papaya",
    alt: "papaya_image",
    images: {
      small: papaya500,
      medium: papaya1000,
      large: papaya1500,
    }
  },
  {
    name: "Spices",
    alt: "spices_image",
    images: {
      small: spices500,
      medium: spices1000,
      large: spices1500,
    }
  },
  {
    name: "Onion",
    alt: "onion_image",
    images: {
      small: onion500,
      medium: onion1000,
      large: onion1500,
    }
  },
  {
    name: "Watermelon",
    alt: "watermelon_image",
    images: {
      small: watermelon500,
      medium: watermelon1000,
      large: watermelon1500,
    }
  },
  {
    name: "Chillies",
    alt: "chilli_image",
    images: {
      small: greenandredchillies500,
      medium: greenandredchillies1000,
      large: greenandredchillies1500,
    }
  },
  {
    name: "Ginger",
    alt: "ginger_image",
    images: {
      small: ginger500,
      medium: ginger1000,
      large: ginger1500,
    }
  },
  {
    name: "Mango",
    alt: "mango_image",
    images: {
      small: mango500,
      medium: mango1000,
      large: mango1500,
    }
  },
  {
    name: "Gooseberry / Amla",
    alt: "avla_image",
    images: {
      small: gooseberry500,
      medium: gooseberry1000,
      large: gooseberry1500,
    }
  },
  {
    name: "Foxnut",
    alt: "foxnut_image",
    images: {
      small: foxnut500,
      medium: foxnut1000,
      large: foxnut1500,
    }
  },
  {
    name: "Mustard & oil",
    alt: "musterdoil_image",
    images: {
      small: mustard500,
      medium: mustard1000,
      large: mustard1500,
    }
  },
];


const Papularproduct = () => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 4000,
    cssEase: "linear",
    touchMove: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <section className='section'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 text-center'>
              <span className="main-heading btn btn-primary" type="button"><b>--- Our Popular Products ---</b></span>
            </div>
          </div>
        </div>
      </section>
      <div className="overflow-hidden grid gap-3 shadow" style={{ marginBottom: '40px' }} >
        <Slider {...settings}>
          {products.map((product, index) => (
            <div key={index} className="px-2">
              <div className="product-card">
                <picture>
                  <source
                    media="(max-width: 500px)"
                    srcSet={product.images.small}
                  />
                  <source
                    media="(max-width: 1000px)"
                    srcSet={product.images.medium}
                  />
                  <img

                    className='img-fluid'
                    src={product.images.large}
                    srcSet={`${product.images.small} 500w, ${product.images.medium} 1000w, ${product.images.large} 1500w`}

                    sizes="(max-width: 576px) 100vw, (max-width: 991px) 50vw, (min-width: 992px) 45vw"
                    alt={product.alt}
                    loading={index === 0 ? "eager" : "lazy"}
                    height="auto"
                    width="auto"
                  />
                </picture>
                <div className="card-body text-center d-flex flex-column align-items-center justify-content-center">
                  <h2 className='main-heading text-primary'>{product.name}</h2>
                  <Link to="/Inqury">
                    <button type="button" className="btn btn-outline-success">
                      <b>Order Now</b>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  )
}

export default Papularproduct;